module.exports = __webpack_public_path__ + "img/shop_example.643c9b43.jpg";